import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import { ComponentMeta, ComponentStory } from '@storybook/react'

import Typography from 'components/UI/Typography/Typography'

import typoArgs, { TypographyArgs } from './TypographyArgs'

export default {
  title: 'Typography',
  component: Typography.Body,
} as ComponentMeta<typeof Typography.Body>

const BodyTemplate: ComponentStory<typeof Typography.Body> = (
  args: TypographyArgs,
) => <Typography.Body {...args} />

const Body = BodyTemplate.bind({})
Body.args = typoArgs

export { Body }
